"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSmall = exports.makeText = exports.makeSubheading = exports.makeTertiary = exports.makeSecondary = exports.makePrimary = exports.makeTitle = void 0;
// TODO: remove nocheck when ready and investigate. Hits errors when alwaysStrict true!
// @ts-nocheck
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("src/providers/theme/helpers");
var margin_1 = __importDefault(require("src/utilities/styled/margin"));
var padding_1 = __importDefault(require("src/utilities/styled/padding"));
var fontColor_1 = __importDefault(require("src/utilities/styled/fontColor"));
var alignSelf_1 = __importDefault(require("src/utilities/styled/alignSelf"));
var textAlign_1 = __importDefault(require("src/utilities/styled/textAlign"));
var truncate_1 = __importDefault(require("src/utilities/styled/truncate"));
var wordBreak_1 = __importDefault(require("src/utilities/styled/wordBreak"));
var makeFontSize_1 = __importDefault(require("src/utilities/styled/makeFontSize"));
var makeLineHeight_1 = __importDefault(require("src/utilities/styled/makeLineHeight"));
var makeFontWeight_1 = __importDefault(require("src/utilities/styled/makeFontWeight"));
var makeTypography = function (type) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), (0, makeFontSize_1.default)(type), (0, makeLineHeight_1.default)(type), (0, makeFontWeight_1.default)(type), fontColor_1.default, alignSelf_1.default, textAlign_1.default, truncate_1.default, wordBreak_1.default, margin_1.default, padding_1.default); };
var makeTitle = function (Component) { return (0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
    return ({ margin: margin });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), makeTypography('title')); };
exports.makeTitle = makeTitle;
var makePrimary = function (Component) { return (0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
    return ({ margin: margin });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), makeTypography('primary')); };
exports.makePrimary = makePrimary;
var makeSecondary = function (Component) { return (0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
    return ({ margin: margin });
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), makeTypography('secondary')); };
exports.makeSecondary = makeSecondary;
var makeTertiary = function (Component) { return (0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
    return ({ margin: margin });
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), makeTypography('tertiary')); };
exports.makeTertiary = makeTertiary;
var makeSubheading = function (Component) { return (0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
    return ({ margin: margin });
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), makeTypography('subheading')); };
exports.makeSubheading = makeSubheading;
var makeText = function (Component) { return (0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
    return ({ margin: margin });
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), makeTypography('text')); };
exports.makeText = makeText;
var makeSmall = function (Component) { return (0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
    return ({ margin: margin });
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), makeTypography('small')); };
exports.makeSmall = makeSmall;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
